import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import api from '../../api/axios';
import * as conv from '../utils/converter'

const Reports = () => {
    // const location = useLocation();
    const [showStatement, setShowStatement] = useState(true);
    const [myCID, setMyCID] = useState('');
    const [inventory, setInventory] = useState([]);
    const [penjualan, setPenjualan] = useState([]);
    const [piutang, setPiutang] = useState([]);
    const [activeTab, setActiveTab] = useState('inventory');


    const formatNumber = (num) => {
        if (typeof num !== 'number') return '';
        const precision = Math.abs(num) < 1 ? 4 : 2;
        return num.toLocaleString(undefined, {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision
        });
    };

    const getTotal = (key) => {
        return inventory.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
    };


    const getTotalJual = (key) => {
        return penjualan.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
    };

    const getTotalPiutang = (key) => {
        return piutang.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
    };
    //consolidation/piutang
    const colors = [
        '#4E79A7', // bold soft blue
        '#F28E2B', // bold pastel orange
        '#E15759', // soft crimson red
        '#76B7B2', // soft teal
        '#59A14F', // modern green
        '#EDC948', // golden yellow
        '#B07AA1', // muted purple
        '#FF9DA7'  // soft coral pink
    ];

    const [user, setUser] = useState({ UserID: '', DisplayName: '' });




    useEffect(() => {
        // const storedCID = localStorage.getItem("cid");
        const token = localStorage.getItem('token');


        if (token) {
            const decoded = jwtDecode(token);
            const { CIDIncluded } = decoded;
            setMyCID(CIDIncluded);
        }
    }, []);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser({ UserID: decoded.UserID, DisplayName: decoded.DisplayName });
            } catch (err) {
                console.error('Invalid token');
            }
        }


        const fetchConsolidatedPiutang = async () => {
            if (!myCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('consolidation/piutang', { cid: 'selectedCID ' }, {
                    headers: { authorization: token },
                });
                console.log('Inventory:', res.data.data)
                setPiutang(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchConsolidatedPiutang()


        const fetchConsolidatedInventory = async () => {
            if (!myCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('consolidation/inventory', { cid: 'selectedCID ' }, {
                    headers: { authorization: token },
                });
                console.log('Inventory:', res.data.data)
                setInventory(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchConsolidatedInventory();

        const fetchConsolidatedAchievement = async () => {
            if (!myCID) return;
            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.post('consolidation/achievement', { cid: 'selectedCID' }, {
                    headers: { authorization: token },
                });
                console.log('Consolidation Achievement:', res.data.data)
                setPenjualan(res.data.data);
            } catch (error) {
                console.error('Error fetching Consolidation Achievement:', error);
            }
        };
        fetchConsolidatedAchievement();




    }, [myCID]);

    return (
        <div className="container-fluid px-4 py-3 page-wrapper">
           <h3 className="fw-bold mb-1">Consolidation Reports</h3>          
            <div className="mb-4 alert alert-info border rounded p-3 shadow-sm">
                <div
                    onClick={() => setShowStatement(!showStatement)}
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: 'pointer' }}
                >
                    <h5 className="mb-0 fw-bold">
                        Info
                    </h5>
                    <span className="text-primary">
                        {showStatement ? '▲ Tutup' : '▼ Buka'}
                    </span>
                </div>

                {showStatement && (
                    <div className="mt-3">
                        <p className="text-body-secondary">
                            Laporan ini menyajikan data konsolidasi <strong>bulan berjalan</strong> yang dihimpun dari seluruh unit terkait.
                            Informasi disusun untuk memberikan gambaran terkini atas kinerja perusahaan dan digunakan sebagai
                            dasar evaluasi serta pengambilan keputusan. Koreksi atau pembaruan data, jika diperlukan, akan dilakukan
                            pada periode selanjutnya.
                        </p>
                        <p>
                            Laporan konsolidasi untuk semua cabang yang ada di sistem, sesuai dengan hak akses yang telah
                            ditentukan untuk user <strong>{user.DisplayName}</strong>.
                        </p>
                    </div>
                )}
            </div>


            <div className="row g-4 mb-4">
                {[
                    { label: 'Persediaan Fisik', value: (conv.formatnumber(getTotal('FisikInventory'))), className: '', warnaText: colors[0] },
                    { label: 'Persediaan Tronik', value: (conv.formatnumber(getTotal('TronikInventory'))), className: '', warnaText: colors[1] },
                    { label: 'Penjualan Fisik', value: (conv.formatnumber(getTotalJual('FisikAchv'))), className: '', warnaText: colors[2] },
                    { label: 'Penjualan Tronik', value: (conv.formatnumber(getTotalJual('TronikAchv'))), className: '', warnaText: colors[3] },
                ].map((item, i) => (
                    <div className="col-md-3" key={i}>
                        <div className="card shadow-sm rounded-4 border-0 bg-light">
                            <div className="card-body p-4">
                                <p className="text-body-secondary mb-1">{item.label}</p>
                                <h4 className={`fw-semibold ${item.className}`} style={{ color: item.warnaText }}>
                                    {item.value.toLocaleString()}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div>


            <div class="">
                <div className="page-tabs">
                    <ul className="nav nav-tabs mb-2" >
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'inventory' ? 'active' : ''}`} onClick={() => setActiveTab('inventory')}>Inventory</button>
                        </li>

                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => setActiveTab('summary')}>Selling Summary</button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'piutang' ? 'active' : ''}`} onClick={() => setActiveTab('piutang')}>Piutang</button>
                        </li>

                    </ul>
                </div>


                <div className="page-content">
                    {activeTab === 'inventory' && (
                        <div className="table-responsive scrollable-table">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Cluster</th>
                                        <th>Inventory Fisik</th>
                                        <th>Inventory Tronik</th>
                                        <th>Total Inventory</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {inventory.map((item) => (
                                        <tr key={item.Cluster}>
                                            <td>{item.CompanyName}</td>
                                            <td>{item.Cluster}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.FisikInventory))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.TronikInventory))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.TotalInventory))}</td>
                                        </tr>
                                    ))}
                                    {inventory.length === 0 && (
                                        <tr>
                                            <td colSpan="7" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                    {inventory.length > 0 && (
                                        <tr className="fw-bold bg-light">
                                            <td colSpan="2" className="text-end">TOTAL</td>
                                            <td className="text-end">{formatNumber(getTotal('FisikInventory'))}</td>
                                            <td className="text-end">{formatNumber(getTotal('TronikInventory'))}</td>
                                            <td className="text-end">{formatNumber(getTotal('TotalInventory'))}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    )}



                    {activeTab === 'summary' && (

                        <div className="table-responsive scrollable-table">
                            {/* <div><p>{JSON.stringify(penjualan)}</p></div> */}
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Cluster</th>
                                        <th>Penjualan Fisik</th>
                                        <th>Penjualan Tronik</th>
                                        <th>Total Penjualan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {penjualan.map((item) => (
                                        <tr key={item.Cluster}>
                                            <td>{item.CompanyName}</td>
                                            <td>{item.Cluster}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.FisikAchv))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.TronikAchv))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.TotalAchv))}</td>
                                        </tr>
                                    ))}
                                    {penjualan.length === 0 && (
                                        <tr>
                                            <td colSpan="8" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                    {penjualan.length > 0 && (
                                        <tr className="fw-bold bg-light">
                                            <td colSpan="2" className="text-end">TOTAL</td>
                                            <td className="text-end">{formatNumber(getTotalJual('FisikAchv'))}</td>
                                            <td className="text-end">{formatNumber(getTotalJual('TronikAchv'))}</td>
                                            <td className="text-end">{formatNumber(getTotalJual('TotalAchv'))}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {activeTab === 'piutang' && (

                        <div className="table-responsive scrollable-table">
                            {/* <div><p>{JSON.stringify(penjualan)}</p></div> */}
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Cluster</th>
                                        <th>Tagihan</th>
                                        <th>Pembayaran</th>
                                        <th>Saldo Tagihan</th>
                                        <th>Unused Payment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {piutang.map((item) => (
                                        <tr key={item.Cluster}>
                                            <td>{item.CompanyName}</td>
                                            <td>{item.ClusterName}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.Tagihan))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.Payment))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.SaldoPiutang))}</td>
                                            <td className="text-end">{formatNumber(parseFloat(item.UnusedPayment))}</td>
                                        </tr>
                                    ))}
                                    {piutang.length === 0 && (
                                        <tr>
                                            <td colSpan="8" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                    {piutang.length > 0 && (
                                        <tr className="fw-bold bg-light">
                                            <td colSpan="2" className="text-end">TOTAL</td>
                                            <td className="text-end">{formatNumber(getTotalPiutang('Tagihan'))}</td>
                                            <td className="text-end">{formatNumber(getTotalPiutang('Payment'))}</td>
                                            <td className="text-end">{formatNumber(getTotalPiutang('SaldoPiutang'))}</td>
                                            <td className="text-end">{formatNumber(getTotalPiutang('UnusedPayment'))}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>
            </div>





        </div>
    );
};

export default Reports;
